exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-mobile .card .wrapper .header .first-col span[data-v-6edd89d4] {\n  font-weight: 600;\n  font-size: 1rem;\n  color: rgba(6, 38, 62, 0.74);\n}\n.container-mobile .card .wrapper .header .second-col .status span[data-v-6edd89d4] {\n  font-size: 0.85rem;\n}\n", ""]);

// exports
